import { ExternalLinks } from '../type'

const faqDomainUrl = 'https://blanklcl.zendesk.com/hc/fr'

export const LCL_EXTERNAL_LINKS_FR: ExternalLinks = {
  cguLink:
    'https://assets.website-files.com/62baffcf7b968d00045514af/633c2d84f343514cadd7c3d0_LCL%20-%20CGU_Plateforme%20de%20gestion%20Okali%20x%20Client%20final_Vdef%20(1).pdf',
  bankingOrganizationPrivacyPolicyLink:
    'https://assets.website-files.com/62baffcf7b968d00045514af/633c5a32c093a77bbf7d89e3_ca_Politique%20de%20protection%20des%20donnees%20Okali%20x%20Essentiel%20Pro_VF-n.pdf',
  brandPrivacyPolicyLink: 'https://www.lcl.fr/politique-protection-des-donnees',
  appStoreLink: 'https://apps.apple.com/us/app/essentiel-pro-lcl/id1618398607',
  googlePlayLink: 'https://play.google.com/store/apps/details?id=com.lcl.pro',
  faq: faqDomainUrl,
  mandateSepa: `${faqDomainUrl}/articles/34615090482589-Comment-ajouter-un-mandat-de-pr%C3%A9l%C3%A8vement`,
  invoicingFaq: `${faqDomainUrl}/articles/34615196558237-Comment-puis-je-cr%C3%A9er-une-facture-ou-un-devis`,
  requestHelp: `${faqDomainUrl}/articles/34615124301853-Comment-contacter-le-service-client-d-essentiel-pro`,
  contactAdvisorPage: 'https://www.lcl.fr/nous-contacter',
  rcProInfo: '',
  decadeGuaranteeInfo: '',
  multiriskInfo: '',
  legalPlaceCompany: '',
  helpNonDiffusible: faqDomainUrl,
  helpNonEligible: faqDomainUrl,
  helpBeneficialOwners: `${faqDomainUrl}/articles/34615183136285-Comment-puis-je-ajouter-modifier-un-b%C3%A9n%C3%A9ficiaire-effectif`,
  helpNonAllowed: `${faqDomainUrl}/articles/34606349286941-Comment-ouvrir-un-compte-Essentiel-pro`,
  urssaf: {
    portal: 'http://autoentrepreneur.urssaf.fr/',
    microEntrepreneurs:
      'https://www.autoentrepreneur.urssaf.fr/portail/accueil/sinformer-sur-le-statut/lessentiel-du-statut.html',
    socialContributions: 'http://www.aquoiserventlescotisations.urssaf.fr/',
    sepaMandate: faqDomainUrl,
    faq: faqDomainUrl,
    tdaeStatusHelp: faqDomainUrl,
    tdaePaymentAuthorization: faqDomainUrl,
    tou: 'https://assets.website-files.com/62baffcf7b968d00045514af/633aedcc31a7e75717e02246_LCL%20-%20CGU%20Tierce%20De%CC%81claration%20Client%20final%20x%20URSSAF-2_VF%20(1).pdf',
  },
  faqWhoIsBlankFor: faqDomainUrl,
  psdFAQ: faqDomainUrl,
  fatcaCGU: '',
  legalLink: 'https://info.essentielpro.lcl.fr',
  supportEmail: 'support@essentielpro.lcl.fr',
  securityEmail: 'securite@essentielpro.lcl.fr',
  leadEmail: '',
  sepaTransfer: faqDomainUrl,
  compareOffers:
    'https://www.lcl.fr/professionnel/compte-bancaire-professionnel/compte-essentiel-pro-en-ligne',
  touBankAccount:
    'https://assets.website-files.com/62baffcf7b968d00045514af/633c2d9892b68fb22a090176_LCL%20-%20Contrat%20cadre%20de%20services%20de%20paiement%20Okali%20x%20client%20final.Vdef%20(1).pdf',
  kycHelp: faqDomainUrl,
  legalStatus: 'https://web.essentielpro.lcl.fr/',
  capitalDeposit:
    'https://www.lcl.fr/professionnel/compte-bancaire-professionnel/compte-essentiel-pro-en-ligne',
  discoverManagementToolsOffer:
    'https://www.lcl.fr/professionnel/compte-bancaire-professionnel/essentiel-pro-gestion',
  sponsorshipFAQ: '',
  priceBrochure:
    'https://assets.website-files.com/62baffcf7b968d00045514af/633b0abd5607b55e289d701d_Plaquette%20tarifaire%20LCL.pdf',
  changeNonDiffusibleCompany: 'https://statut-diffusion-sirene.insee.fr',
  sponsorshipInvitationLink: '',
  transparencyPolicy: '',
  requestDeviceResetFAQ: `${faqDomainUrl}/articles/34606384705949-Comment-faire-pour-changer-mon-appareil-de-confiance`,
  accountClosingFaq: `${faqDomainUrl}/articles/34610984822941-Comment-puis-je-cl%C3%B4turer-mon-compte`,
  bankScamPreventionLink: '',
  transferFAQ: `${faqDomainUrl}/articles/34610971307933-Sous-quels-d%C3%A9lais-mon-virement-sera-t-il-re%C3%A7u`,
  atecoCodeFAQ: '',
  partitaIVACertificateFAQ: '',
}
